import { Placeholder } from 'react-bootstrap';
import { Breadcrumbs } from '@shared-components';
import { useTranslation } from 'react-i18next';

export const ShopPlaceholder = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs pageTitle={t('header.properties')} />
      <div className='container py-5'>
        <div className='row'>
          {/* Hero/Header Section */}
          <div className='col-12 mb-4'>
            <Placeholder as='h1' animation='wave' style={{ height: '48px' }} />
            <Placeholder
              as='p'
              animation='wave'
              style={{ height: '24px', width: '70%' }}
              className='mt-2'
            />
          </div>

          {/* Main Content Sections */}
          <div className='col-lg-8 col-12'>
            {/* Section 1 */}
            <div className='mb-5'>
              <Placeholder
                as='h2'
                animation='wave'
                style={{ height: '32px', width: '60%' }}
                className='mb-3'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '95%' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '85%' }}
              />
            </div>

            {/* Section 2 */}
            <div className='mb-5'>
              <Placeholder
                as='h2'
                animation='wave'
                style={{ height: '32px', width: '50%' }}
                className='mb-3'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '90%' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '75%' }}
              />
            </div>

            {/* Section 3 */}
            <div className='mb-5'>
              <Placeholder
                as='h2'
                animation='wave'
                style={{ height: '32px', width: '65%' }}
                className='mb-3'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '98%' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '88%' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '20px', width: '80%' }}
              />
            </div>
          </div>

          {/* Sidebar */}
          <div className='col-lg-4 col-12'>
            <div className='mb-4'>
              <Placeholder
                as='div'
                animation='wave'
                style={{ height: '200px' }}
                className='mb-3'
              />
              <Placeholder
                as='h3'
                animation='wave'
                style={{ height: '24px', width: '80%' }}
                className='mb-2'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '18px' }}
                className='mb-1'
              />
              <Placeholder
                as='p'
                animation='wave'
                style={{ height: '18px', width: '70%' }}
              />
            </div>

            <div className='mb-4'>
              <Placeholder
                as='h4'
                animation='wave'
                style={{ height: '20px', width: '60%' }}
                className='mb-3'
              />
              <Placeholder
                as='div'
                animation='wave'
                style={{ height: '16px', width: '90%' }}
                className='mb-2'
              />
              <Placeholder
                as='div'
                animation='wave'
                style={{ height: '16px', width: '85%' }}
                className='mb-2'
              />
              <Placeholder
                as='div'
                animation='wave'
                style={{ height: '16px', width: '75%' }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
